export const findModule = moduleType => ({ value }) => value === moduleType;
